import TabSheet from './TabSheet'
import './TabSheet.css'

export default TabSheet 



// WEBPACK FOOTER //
// ./src/features/Personal/components/TabSheet/index.js